var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-slider",
    _vm._b(
      {
        ref: _vm.name,
        attrs: {
          value: _vm.value,
          width: "100%",
          tooltip: _vm.tooltip,
          "tooltip-dir": "bottom",
          "bg-style": _vm.bgStyle,
          "tooltip-style": _vm.tooltipStyle,
          "process-style": _vm.processStyle,
          "slider-style": _vm.sliderStyle,
          interval: _vm.interval
        },
        on: { callback: _vm.onChange }
      },
      "vue-slider",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }